import * as React from 'react';
import { View, StyleSheet } from 'react-native';
import Animated, { useAnimatedScrollHandler } from 'react-native-reanimated';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { noop } from 'lodash';
import { selectIsInvestWalkthroughActive } from 'reducers/selectors/walkthrough';
import { getSearchResults } from '../actions';
import DoItYourselfFunds from './DoItYourselfFunds';
import ReadyMadeFundsView from './ReadyMadeFundsView';
import { selectTradingAccount } from '../reducers/selectors';
import { isWeb } from '../../../constants';
const SecclDiscoverShortcuts = ({ scrollX, scrollYReadyMade, scrollYDoItYourself, secclHorizontalScrollViewRef, startInDoItYourself, }) => {
    const { contentWidth } = useAppFrameDimensions(isWeb);
    const dispatch = useAppDispatch();
    const tradingAccount = useAppSelector(selectTradingAccount);
    const hasFunded = tradingAccount?.hasFunded;
    const isInvestWalkthroughActive = useAppSelector(selectIsInvestWalkthroughActive);
    React.useEffect(() => {
        // first fetch is faster, making ui more responsive
        dispatch(getSearchResults('seccl', undefined, undefined, undefined, false));
        dispatch(getSearchResults('seccl'));
    }, []);
    const scrollXHandler = useAnimatedScrollHandler(({ contentOffset }) => {
        // eslint-disable-next-line no-param-reassign
        scrollX.value = contentOffset.x;
    }, []);
    React.useEffect(() => {
        if (startInDoItYourself !== false && (startInDoItYourself || hasFunded) && !isInvestWalkthroughActive) {
            const timeout = setTimeout(() => {
                secclHorizontalScrollViewRef.current?.scrollToEnd({ animated: false });
            }, 100);
            return () => clearTimeout(timeout);
        }
        return noop;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (<View style={styles.flex}>
      <Animated.ScrollView horizontal pagingEnabled decelerationRate="fast" scrollEventThrottle={16} onScroll={scrollXHandler} ref={secclHorizontalScrollViewRef} showsHorizontalScrollIndicator={false}>
        <View style={[{ width: contentWidth }, styles.item]}>
          <ReadyMadeFundsView scrollY={scrollYReadyMade}/>
        </View>
        <View style={[{ width: contentWidth }, styles.item]}>
          <DoItYourselfFunds scrollY={scrollYDoItYourself}/>
        </View>
      </Animated.ScrollView>
    </View>);
};
export default React.memo(SecclDiscoverShortcuts);
const styles = StyleSheet.create({
    flex: {
        flex: 1,
    },
    item: {
        flex: 1,
    },
});
